import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
{
    id: "po-07-h6v1-01",
    name: "PO 01 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "6", x: 41, y: 238, width: 249, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 41, y: 432, width: 249, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 238, width: 230, height: 379, rotation: 0, imageRotation: 0 },
            { id: "1", x: 609, y: 238, width: 240, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 432, width: 240, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 857, y: 238, width: 240, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 857, y: 432, width: 240, height: 185, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h6v1-02",
    name: "PO 02 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 44, y: 160, width: 480, height: 349, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 44, y: 517, width: 236, height: 175, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 517, width: 236, height: 175, rotation: 0, imageRotation: 0 },
        { id: "4", x: 609, y: 160, width: 199, height: 172, rotation: 0, imageRotation: 0 },
        { id: "5", x: 609, y: 340, width: 199, height: 172, rotation: 0, imageRotation: 0 },
        { id: "6", x: 609, y: 520, width: 199, height: 172, rotation: 0, imageRotation: 0 },
        { id: "7", x: 816, y: 160, width: 275, height: 532, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-03",
    name: "PO 03 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 46, y: 188, width: 480, height: 354, rotation: 0, imageRotation: 0 },
        { id: "2", x: 609, y: 131, width: 480, height: 342, rotation: 0, imageRotation: 0 },
        { id: "3", x: 609, y: 481, width: 322, height: 242, rotation: 0, imageRotation: 0 },
        { id: "4", x: 939, y: 481, width: 150, height: 242, rotation: 0, imageRotation: 0 },
        { id: "5", x: 46, y: 550, width: 155, height: 116, rotation: 0, imageRotation: 0 },
        { id: "6", x: 209, y: 550, width: 155, height: 116, rotation: 0, imageRotation: 0 },
        { id: "7", x: 372, y: 550, width: 154, height: 116, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-04",
    name: "PO 04 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 41, y: 124, width: 240, height: 197, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 124, width: 239, height: 197, rotation: 0, imageRotation: 0 },
        { id: "3", x: 41, y: 329, width: 240, height: 197, rotation: 0, imageRotation: 0 },
        { id: "4", x: 289, y: 329, width: 239, height: 197, rotation: 0, imageRotation: 0 },
        { id: "5", x: 41, y: 534, width: 240, height: 196, rotation: 0, imageRotation: 0 },
        { id: "6", x: 289, y: 534, width: 239, height: 196, rotation: 0, imageRotation: 0 },
        { id: "7", x: 668, y: 124, width: 368, height: 606, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-05",
    name: "PO 05 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 54, y: 220, width: 251, height: 203, rotation: 0, imageRotation: 0 },
        { id: "2", x: 54, y: 431, width: 251, height: 203, rotation: 0, imageRotation: 0 },
        { id: "3", x: 313, y: 220, width: 251, height: 414, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 220, width: 251, height: 203, rotation: 0, imageRotation: 0 },
        { id: "5", x: 572, y: 431, width: 251, height: 203, rotation: 0, imageRotation: 0 },
        { id: "6", x: 831, y: 220, width: 251, height: 203, rotation: 0, imageRotation: 0 }, 
        { id: "7", x: 831, y: 431, width: 251, height: 203, rotation: 0, imageRotation: 0 }
       
    ],
},

{
    id: "po-07-h6v1-06",
    name: "PO 06 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 87, y: 112, width: 388, height: 311, rotation: 0, imageRotation: 0 },
        { id: "2", x: 87, y: 431, width: 388, height: 311, rotation: 0, imageRotation: 0 },
        { id: "3", x: 483, y: 112, width: 358, height: 630, rotation: 0, imageRotation: 0 },
        { id: "4", x: 849, y: 112, width: 200, height: 152, rotation: 0, imageRotation: 0 },
        { id: "5", x: 849, y: 272, width: 200, height: 152, rotation: 0, imageRotation: 0 },
        { id: "6", x: 849, y: 432, width: 200, height: 151, rotation: 0, imageRotation: 0 },
        { id: "7", x: 849, y: 591, width: 200, height: 151, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-07",
    name: "PO 07 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 42, y: 131, width: 246, height: 193, rotation: 0, imageRotation: 0 },
        { id: "2", x: 42, y: 332, width: 246, height: 193, rotation: 0, imageRotation: 0 },
        { id: "3", x: 42, y: 533, width: 246, height: 192, rotation: 0, imageRotation: 0 },
        { id: "4", x: 296, y: 131, width: 319, height: 594, rotation: 0, imageRotation: 0 },
        { id: "5", x: 623, y: 131, width: 471, height: 387, rotation: 0, imageRotation: 0 },
        { id: "6", x: 623, y: 526, width: 232, height: 199, rotation: 0, imageRotation: 0 },
        { id: "7", x: 863, y: 526, width: 231, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-08",
    name: "PO 08 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 62, y: 166, width: 305, height: 522, rotation: 0, imageRotation: 0 },
        { id: "2", x: 375, y: 166, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "3", x: 375, y: 343, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "4", x: 375, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 611, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 },
        { id: "6", x: 847, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 },
        { id: "7", x: 611, y: 166, width: 464, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-09",
    name: "PO 09 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 62, y: 166, width: 305, height: 522, rotation: 0, imageRotation: 0 },
        { id: "2", x: 375, y: 166, width: 464, height: 346, rotation: 0, imageRotation: 0 },
        { id: "3", x: 375, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 },
        { id: "4", x: 611, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 847, y: 166, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "6", x: 847, y: 343, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "7", x: 847, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 }     
    ],
},

{
    id: "po-07-h6v1-10",
    name: "PO 10 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 62, y: 166, width: 465, height: 345, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 62, y: 519, width: 229, height: 169, rotation: 0, imageRotation: 0 },
        { id: "3", x: 299, y: 519, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "4", x: 535, y: 166, width: 304, height: 522, rotation: 0, imageRotation: 0 },
        { id: "5", x: 847, y: 166, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "6", x: 847, y: 343, width: 228, height: 169, rotation: 0, imageRotation: 0 },
        { id: "7", x: 847, y: 520, width: 228, height: 168, rotation: 0, imageRotation: 0 }
    ],
}
];